<template>
  <div class="error-container">
    <div class="error-container__message-container">
      <span class="mb2">Merci de vous connecter à un dossier.</span>
      <button class="change-dossier user-panel_button--is-grey">
        Changer de dossier
      </button>
      <ChangeDossier />
    </div>
  </div>
</template>

<script>
import ChangeDossier from '@/modules/changer-dossier/ChangeDossier.vue';

export default {
  name: 'DossierErreur',
  components: { ChangeDossier },
};
</script>

<style lang="scss" scoped>
  .user-panel_button--is-grey {
      border-radius: 20px;
      font-size: 12px;
      font-weight: $font-weight-bold;
      padding: 13px 20px;
      border: 1px solid $main-font-color;
      background: none;
  }
  .error-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    &__message-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background-color: $white;
      padding: 2rem;
      span {
        display: inline-block;
        font-weight: $font-weight-bold;
      }
    }
  }
</style>
